import { gql } from '@apollo/client';

export const GET_WRITERS = gql`
  {
    userListWriters {
      id
      name
      email
      status
      canPublish
    }
  }
`;

export const UPDATE_WRITER = gql`
  mutation updateWriter($id: String!, $name: String!, $responsibleEditor: String, $countries: [String!], $email: String! ) {
    updateWriter(id: $id, input:{ name: $name, responsibleEditor: $responsibleEditor, countries: $countries, email: $email }) {
      id
      name
    }
  }
`;

export const SET_WRITER_PUBLISH_PERMISSION = gql`
  mutation publishPermission($id: String!, $canPublish: Boolean!) {
    publishPermission(id: $id, canPublish: $canPublish) {
      id
      name
      email
      status
      canPublish
    }
  }
`;

export const ACTIVE_WRITER = gql`
  mutation activeUser($id: String!) {
    activeUser(id: $id) {
      id
      name
      email
      status
    }
  }
`;

export const DEACTIVATE_WRITER = gql`
  mutation deactiveUser($id: String!) {
    deactiveUser(id: $id) {
      id
      name
      email
      status
    }
  }
`;

export const REMOVE_WRITER = gql`
  mutation removeUser($id: String!) {
    removeUser(id: $id) {
      id
      name
      email
      status
    }
  }
`;
